import { useState, useEffect } from 'react';
import api from '../../services/api';
import Modal from '../UI/Modal';

const COULEURS_PRESET = [
    '#4f46e5', '#16a34a', '#dc2626', '#d97706',
    '#2563eb', '#db2777', '#ea580c', '#0891b2',
];

export default function SecteurManager() {
    const [secteurs, setSecteurs] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState(null);
    const [confirmAction, setConfirmAction] = useState(null);
    const [form, setForm] = useState({
        nom: '', couleur: '#4f46e5', adressChu: '', actif: true,
    });

    useEffect(() => { loadSecteurs(); }, []);

    const loadSecteurs = async () => {
        try {
            const res = await api.get('/secteurs');
            setSecteurs(res.data.member || []);
        } catch (err) {
            console.error(err);
        }
    };

    const openCreate = () => {
        setSelected(null);
        setForm({ nom: '', couleur: '#4f46e5', adressChu: '', actif: true });
        setShowModal(true);
    };

    const openEdit = (secteur) => {
        setSelected(secteur);
        setForm({
            nom: secteur.nom || '',
            couleur: secteur.couleur || '#4f46e5',
            adressChu: secteur.adressChu || '',
            actif: secteur.actif ?? true,
        });
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (selected) {
                const id = selected.id || selected['@id']?.split('/').pop();
                await api.patch(`/secteurs/${id}`, form, {
                    headers: { 'Content-Type': 'application/merge-patch+json' }
                });
            } else {
                await api.post('/secteurs', form, {
                    headers: { 'Content-Type': 'application/ld+json' }
                });
            }
            setShowModal(false);
            loadSecteurs();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        try {
            await api.delete(`/secteurs/${id}`);
            setConfirmAction(null);
            loadSecteurs();
        } catch (err) {
            console.error(err);
        }
    };

    const toggleActif = async (secteur) => {
        const id = secteur.id || secteur['@id']?.split('/').pop();
        try {
            await api.patch(`/secteurs/${id}`, { actif: !secteur.actif }, {
                headers: { 'Content-Type': 'application/merge-patch+json' }
            });
            loadSecteurs();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0 }}>Secteurs ({secteurs.length})</h3>
                <button onClick={openCreate} style={addButtonStyle}>+ Ajouter un secteur</button>
            </div>

            <div style={{ backgroundColor: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,0.07)' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                    <tr style={{ backgroundColor: '#f8fafc' }}>
                        <th style={thStyle}>Couleur</th>
                        <th style={thStyle}>Nom</th>
                        <th style={thStyle}>Adresse CHU</th>
                        <th style={thStyle}>Actif</th>
                        <th style={thStyle}>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {secteurs.map(s => (
                        <tr key={s.id} style={{ borderTop: '1px solid #f0f0f0', opacity: s.actif ? 1 : 0.5 }}>
                            <td style={tdStyle}>
                                <div style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '8px',
                                    backgroundColor: s.couleur,
                                }} />
                            </td>
                            <td style={tdStyle}>
                  <span style={{
                      padding: '3px 10px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '700',
                      backgroundColor: s.couleur + '22',
                      color: s.couleur,
                  }}>
                    {s.nom}
                  </span>
                            </td>
                            <td style={{ ...tdStyle, fontSize: '12px', color: '#888' }}>{s.adressChu}</td>
                            <td style={tdStyle}>
                                <button
                                    onClick={() => toggleActif(s)}
                                    style={{
                                        padding: '3px 10px',
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        border: 'none',
                                        cursor: 'pointer',
                                        backgroundColor: s.actif ? '#dcfce7' : '#fee2e2',
                                        color: s.actif ? '#16a34a' : '#dc2626',
                                    }}
                                >
                                    {s.actif ? 'Actif' : 'Inactif'}
                                </button>
                            </td>
                            <td style={tdStyle}>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <button onClick={() => openEdit(s)} style={editButtonStyle}>✏️</button>
                                    <button onClick={() => setConfirmAction({ type: 'delete', item: s })} style={deleteButtonStyle}>🗑️</button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    {secteurs.length === 0 && (
                        <tr>
                            <td colSpan={5} style={{ ...tdStyle, textAlign: 'center', color: '#888', padding: '32px' }}>
                                Aucun secteur
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>

            {/* Modale création/édition */}
            {showModal && (
                <Modal title={selected ? 'Modifier le secteur' : 'Nouveau secteur'} onClose={() => setShowModal(false)}>
                    <form onSubmit={handleSubmit}>
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Nom *</label>
                            <input
                                type="text"
                                value={form.nom}
                                onChange={e => setForm({ ...form, nom: e.target.value })}
                                style={inputStyle}
                                placeholder="ex: NANCY"
                                required
                            />
                        </div>
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Adresse du CHU *</label>
                            <input
                                type="text"
                                value={form.adresseChu}
                                onChange={e => setForm({ ...form, adressChu: e.target.value })}
                                style={inputStyle}
                                placeholder="ex: 29 avenue du Maréchal de Lattre de Tassigny, Nancy"
                                required
                            />
                        </div>
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Couleur</label>
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                                {COULEURS_PRESET.map(c => (
                                    <div
                                        key={c}
                                        onClick={() => setForm({ ...form, couleur: c })}
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '8px',
                                            backgroundColor: c,
                                            cursor: 'pointer',
                                            border: form.couleur === c ? '3px solid #1a1a2e' : '3px solid transparent',
                                            boxShadow: form.couleur === c ? '0 0 0 2px white inset' : 'none',
                                        }}
                                    />
                                ))}
                                <input
                                    type="color"
                                    value={form.couleur}
                                    onChange={e => setForm({ ...form, couleur: e.target.value })}
                                    style={{ width: '32px', height: '32px', borderRadius: '8px', border: 'none', cursor: 'pointer', padding: 0 }}
                                    title="Couleur personnalisée"
                                />
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                            <button type="button" onClick={() => setShowModal(false)} style={cancelButtonStyle}>Annuler</button>
                            <button type="submit" style={submitButtonStyle} disabled={loading}>
                                {loading ? 'Enregistrement...' : selected ? 'Modifier' : 'Créer'}
                            </button>
                        </div>
                    </form>
                </Modal>
            )}

            {/* Confirmation suppression */}
            {confirmAction && (
                <Modal title="Supprimer le secteur" onClose={() => setConfirmAction(null)}>
                    <p style={{ marginBottom: '24px', color: '#444' }}>
                        Supprimer le secteur <strong>{confirmAction.item.nom}</strong> ? Les patients associés n'auront plus de secteur.
                    </p>
                    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                        <button onClick={() => setConfirmAction(null)} style={cancelButtonStyle}>Annuler</button>
                        <button
                            onClick={() => handleDelete(confirmAction.item.id || confirmAction.item['@id']?.split('/').pop())}
                            style={{ ...submitButtonStyle, backgroundColor: '#ef4444' }}
                        >
                            Supprimer
                        </button>
                    </div>
                </Modal>
            )}
        </div>
    );
}

const addButtonStyle = { padding: '8px 16px', backgroundColor: '#4f46e5', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' };
const editButtonStyle = { padding: '4px 8px', backgroundColor: '#f0f2f5', border: 'none', borderRadius: '6px', cursor: 'pointer' };
const deleteButtonStyle = { padding: '4px 8px', backgroundColor: '#fee2e2', border: 'none', borderRadius: '6px', cursor: 'pointer' };
const thStyle = { padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: '600', color: '#888' };
const tdStyle = { padding: '12px 16px', fontSize: '14px', color: '#333' };
const fieldStyle = { marginBottom: '16px' };
const labelStyle = { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#444' };
const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' };
const cancelButtonStyle = { padding: '10px 20px', backgroundColor: '#f0f2f5', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' };
const submitButtonStyle = { padding: '10px 20px', backgroundColor: '#4f46e5', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' };